exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#profile h2[data-v-0af5b11a]{font-weight:700;font-size:23px;line-height:41px;border-bottom:1px solid #eee;padding:15px;color:#686868}@media screen and (min-width:768px){.main-center[data-v-0af5b11a]{width:100%;max-width:1036px;margin:0 auto}}", ""]);

// exports
